import {
  put, takeLatest, all, takeEvery,
} from 'redux-saga/effects';
import { notification } from 'antd';
import PayoutActions, { payoutActionTypes } from '@Actions/payoutActions';
import TrackerActions from '@Actions/trackerActions';
import PayoutServices from '@Services/payoutServices';

/**
 * @param action
 */
function* _getPoPayment(action) {
  try {
    yield put(PayoutActions.getPoPaymentLoading(true, action.poPaymentId));
    const payout = yield PayoutServices.getPoPayment(action.page, action.poId, action.poPaymentId, action?.status);
    if (!payout.success) {
      notification.open({
        type: 'error',
        message: payout?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      yield put(PayoutActions.getPoPaymentSuccess(payout, action.poPaymentId));
    }
    yield put(PayoutActions.getPoPaymentLoading(false, action.poPaymentId));
  } catch (error) {
    yield put(PayoutActions.getPoPaymentLoading(false, action.poPaymentId));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(payoutActionTypes.GET_PO_PAYMENT.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getPoPayment() {
  yield takeLatest(payoutActionTypes.GET_PO_PAYMENT.REQUEST, _getPoPayment);
}

/**
 * @param action
 */
function* _createPoPayment(action) {
  try {
    yield put(PayoutActions.createPoPaymentLoading(true));
    const Payout = yield PayoutServices.createPoPayment(action.payload);
    if (Payout.success) {
      yield put(TrackerActions.trackAction(payoutActionTypes.CREATE_PO_PAYMENT.SUCCESS, {
        request: action?.payload,
        response: Payout,
      }));
      notification.open({
        type: 'success',
        message: 'Po Payment Successfully added',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(Payout.payment);
      }
    } else {
      notification.open({
        type: 'error',
        message: Payout?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PayoutActions.createPoPaymentLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(PayoutActions.createPoPaymentLoading(false));
    yield put(TrackerActions.trackAction(payoutActionTypes.CREATE_PO_PAYMENT.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* createPoPayment() {
  yield takeLatest(payoutActionTypes.CREATE_PO_PAYMENT.REQUEST, _createPoPayment);
}

/**
 * @param action
 */
function* _createPaymentFlow(action) {
  try {
    yield put(PayoutActions.createPaymentFlowLoading(true));
    const paymentFlow = yield PayoutServices.createPaymentFlow(action.payload);
    if (paymentFlow.success) {
      yield put(TrackerActions.trackAction(payoutActionTypes.CREATE_PAYOUT_FLOW.SUCCESS, {
        request: action?.payload,
        response: paymentFlow,
      }));
      notification.open({
        type: 'success',
        message: 'Payment Flow Successfully added',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(paymentFlow);
      }
    } else {
      notification.open({
        type: 'error',
        message: paymentFlow?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PayoutActions.createPaymentFlowLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(PayoutActions.createPaymentFlowLoading(false));
    yield put(TrackerActions.trackAction(payoutActionTypes.CREATE_PAYOUT_FLOW.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* createPaymentFlow() {
  yield takeLatest(payoutActionTypes.CREATE_PAYOUT_FLOW.REQUEST, _createPaymentFlow);
}

/**
 * @param action
 */
function* _updatePaymentFlow(action) {
  try {
    yield put(PayoutActions.updatePaymentFlowLoading(true));
    const paymentFlow = yield PayoutServices.updatePaymentFlow(action.payload);
    if (paymentFlow.success) {
      yield put(TrackerActions.trackAction(payoutActionTypes.UPDATE_PAYOUT_FLOW.SUCCESS, {
        request: action?.payload,
        response: paymentFlow,
      }));
      notification.open({
        type: 'success',
        message: 'Payment Flow Successfully added',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(paymentFlow);
      }
    } else {
      notification.open({
        type: 'error',
        message: paymentFlow.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PayoutActions.updatePaymentFlowLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(PayoutActions.updatePaymentFlowLoading(false));
    yield put(TrackerActions.trackAction(payoutActionTypes.UPDATE_PAYOUT_FLOW.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* updatePaymentFlow() {
  yield takeLatest(payoutActionTypes.UPDATE_PAYOUT_FLOW.REQUEST, _updatePaymentFlow);
}

/**
 * @param action
 */
function* _createConnectSession(action) {
  try {
    yield put(PayoutActions.createConnectSessionLoading(true));
    const session = yield PayoutServices.createConnectSession(action.payload);
    if (!session.error) {
      localStorage.setItem('piceSessionToken', session?.pice_response?.data?.sessionToken);
      PayoutActions.createConnectSessionSuccess(session);
      if (action.callback) {
        action.callback(session);
      }
    } else {
      notification.open({
        type: 'error',
        message: session?.pice_response?.meta?.message,
        duration: 6,
        placement: 'top',
      });
    }
    yield put(PayoutActions.createConnectSessionLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(PayoutActions.createConnectSessionLoading(false));
    yield put(TrackerActions.trackAction(payoutActionTypes.CREATE_CONNECT_SESSION.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* createConnectSession() {
  yield takeLatest(payoutActionTypes.CREATE_CONNECT_SESSION.REQUEST, _createConnectSession);
}

/**
 * @param action
 */
function* _createPaymentSession(action) {
  try {
    yield put(PayoutActions.createPaymentSessionLoading(true));
    const session = yield PayoutServices.createPaymentSession(action.payload);
    if (session?.pice_response?.meta?.code === 'SUCCESS') {
      localStorage.setItem('piceSessionTokenPayment', session?.pice_response?.data?.sessionToken);
      PayoutActions.createPaymentSessionLoading(session);
      if (action?.callback) {
        action.callback(session);
      }
    } else {
      notification.open({
        type: 'error',
        message: session.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PayoutActions.createPaymentSessionLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(payoutActionTypes.CREATE_PAYMENT_SESSION.ERROR, {
      request: action,
      error,
    }));
    yield put(PayoutActions.createPaymentSessionLoading(false));
  }
}

/**
 *
 */
function* createPaymentSession() {
  yield takeEvery(payoutActionTypes.CREATE_PAYMENT_SESSION.REQUEST, _createPaymentSession);
}

/**
 * @param action
 */
function* _connectSession(action) {
  try {
    yield put(PayoutActions.connectSessionLoading(true));
    const session = yield PayoutServices.connectSession(action.payload);
    if (session.success) {
      // notification.open({
      PayoutActions.connectSessionLoading(session);
      if (action?.callback) {
        action.callback(session);
      }
    } else {
      notification.open({
        type: 'error',
        message: session.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PayoutActions.connectSessionLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(PayoutActions.connectSessionLoading(false));
  }
}

/**
 *
 */
function* connectSession() {
  yield takeLatest(payoutActionTypes.SET_SESSION.REQUEST, _connectSession);
}

/**
 * @param action
 */
function* _verifyPayment(action) {
  try {
    yield put(PayoutActions.verifyPaymentLoading(true));
    const session = yield PayoutServices.verifyPayment(action.payload);
    if (!session.error) {
      notification.open({
        type: 'success',
        message: 'Payment verify Succesful',
        duration: 4,
        placement: 'top',
      });
      PayoutActions.verifyPaymentSuccess(session);
      if (action.callback) {
        action.callback(session);
      }
    } else {
      notification.open({
        type: 'error',
        message: session?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PayoutActions.verifyPaymentLoading(false));
    yield put(PayoutActions.createConnectSessionLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(PayoutActions.verifyPaymentLoading(false));
    yield put(PayoutActions.createConnectSessionLoading(false));
  }
}

/**
 *
 */
function* verifyPayment() {
  yield takeLatest(payoutActionTypes.PAYMENT_VERIFY.REQUEST, _verifyPayment);
}

/**
 * @param action
 */
function* _getPendingPoPayment() {
  try {
    yield put(PayoutActions.getPendingPoPaymentLoading(true));
    const payout = yield PayoutServices.getPendingPoPayment();
    if (!payout.success) {
      notification.open({
        type: 'error',
        message: payout?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      yield put(PayoutActions.getPendingPoPaymentSuccess(payout));
    }
    yield put(PayoutActions.getPendingPoPaymentLoading(false));
  } catch (error) {
    yield put(PayoutActions.getPendingPoPaymentLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */
function* getPendingPoPayment() {
  yield takeLatest(payoutActionTypes.GET_PENDING_PO_PAYMENT.REQUEST, _getPendingPoPayment);
}

/**
 *
 */
export default function* payoutSaga() {
  yield all([
    getPoPayment(),
    createPoPayment(),
    createPaymentFlow(),
    updatePaymentFlow(),
    createConnectSession(),
    verifyPayment(),
    createPaymentSession(),
    connectSession(),
    getPendingPoPayment(),
  ]);
}
